import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthLayout, Field, FormError } from '../../components/Form.js';
import { ApiError, apiRequest } from '../../lib/api.js';

/**
 * Story #5 — starts a reset. The response is identical whether or not the
 * address has an account, so this cannot be used to enumerate users.
 */
export function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await apiRequest('/auth/forgot-password', {
        method: 'POST',
        body: { email },
        anonymous: true,
      });
      navigate(`/reset-password?email=${encodeURIComponent(email)}`);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Could not start a reset.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we'll send you a reset code."
      footer={
        <p className="muted">
          <Link to="/signin">Back to sign in</Link>
        </p>
      }
    >
      <form onSubmit={onSubmit} noValidate>
        <Field label="Email" htmlFor="email">
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
          />
        </Field>

        <FormError message={error} />

        <button type="submit" disabled={busy} className="block">
          {busy ? 'Sending…' : 'Send reset code'}
        </button>
      </form>
    </AuthLayout>
  );
}
